// import React, { useState } from "react";
// import { Box, Button, TextField, Typography, Paper } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { API_BASE } from "../api/index.js";
 
// const ForgotPassword = () => {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async () => {
//     if (!email.trim()) {
//       setError("Email is required");
//       return;
//     }

//     if (!/\S+@\S+\.\S+/.test(email)) {
//       setError("Please enter a valid email address");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");
//       setMessage("");

//       const response = await fetch(`${API_BASE}/forgot-password`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setMessage(data.message);
//         // Optionally redirect after a delay
//         setTimeout(() => {
//           navigate("/login");
//         }, 3000);
//       } else {
//         setError(data.message || "Failed to send reset email");
//       }

//     } catch (error) {
//       console.error("Forgot password error:", error);
//       setError("Network error. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//          sx={{
//            minHeight: "100vh",  // ensures full height
//            display: "flex",
//            alignItems: "center",
//            justifyContent: "center",
//            backgroundImage: "url('/assets/shape.png'), url('/assets/MainBg.png')",
//            backgroundSize: "cover, cover",
//            backgroundPosition: "center, center",
//            px: 2,
//            overflowX: "hidden", // only block horizontal scrollbar
//            overflowY: "auto",   // vertical auto adjust
//          }}
//        >
//          <Paper
//            elevation={6}
//            sx={{
//              display: "flex",
//              flexDirection: "column",
//              borderRadius: "16px",
//              px: { xs: 2, sm: 4 },
//              pt: { xs: 2, sm: 4 },
//              pb: 0,
//              width: { xs: "100%", sm: "450px", md: "500px", lg: "520px" },
//              maxHeight: "100vh", // prevents overflow in small screens
//              overflowY: "auto", // allow scrolling inside only if needed
//            }}
//          >
//        <Box sx={{ mt: "clamp(9rem, 10vh, 9rem)" }}>
 
//           {/* Title */}
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             sx={{
//               fontSize: "clamp(1.25rem, 2vw, 1.75rem)",
//               mb: "1.5rem",
//               textAlign: "center",
//               fontFamily:'"Nunito Sans", "Roboto", "Arial", sans-serif',
//             }}
//           >
//             Forgot Password
//           </Typography>
 
//           {/* Subtitle */}
//           <Typography
//             variant="body2"
//             color="text.secondary"
//             sx={{
//               mb: 4,
//               fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
//               textAlign: "center",
//               lineHeight: 1.5,
//               px: { xs: 1, sm: 2 },
//               fontFamily:'"Nunito Sans", "Roboto", "Arial", sans-serif',
//             }}
//           >
//             Please enter your registered email address to receive a password reset
//             link.
//           </Typography>

//           {/* Success Message */}
//           {message && (
//             <Typography
//               variant="body2"
//               sx={{
//                 mb: 2,
//                 p: 2,
//                 backgroundColor: "#d4edda",
//                 color: "#155724",
//                 borderRadius: "8px",
//                 textAlign: "center",
//                 fontSize: "0.9rem",
//               }}
//             >
//               {message}
//             </Typography>
//           )}

//           {/* Error Message */}
//           {error && (
//             <Typography
//               variant="body2"
//               sx={{
//                 mb: 2,
//                 p: 2,
//                 backgroundColor: "#f8d7da",
//                 color: "#721c24",
//                 borderRadius: "8px",
//                 textAlign: "center",
//                 fontSize: "0.9rem",
//               }}
//             >
//               {error}
//             </Typography>
//           )}
 
//           {/* Label */}
//           <Typography
//             variant="body2"
//             fontWeight="500"
//             sx={{ mb: 1, fontSize: "clamp(0.85rem, 1.2vw, 0.95rem)" , fontFamily:'"Nunito Sans", "Roboto", "Arial", sans-serif',}}
           
//           >
//             Email Address:
//           </Typography>
 
//           {/* Input */}
//           <TextField
//             fullWidth
//             type="email"
//             placeholder="Enter your email"
//             variant="outlined"
//             value={email}
//             onChange={(e) => {
//               setEmail(e.target.value);
//               if (error) setError("");
//             }}
//             error={!!error}
//             sx={{
//               mb: 4,
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: "10px",
//                 backgroundColor: "#F7F9FC",
//                 fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
//               },
//             }}
//           />
 
//           {/* Button */}
//           <Button
//             fullWidth
//             variant="contained"
//             disabled={loading}
//             sx={{
//               background: "linear-gradient(90deg, #5A78FF 0%, #4E62F2 100%)",
//               textTransform: "none",
//               fontSize: "clamp(14px, 1.8vw, 16px)",
//               fontWeight: 500,
//               py: { xs: 1.2, sm: 1.5 },
//               mt: { xs: 3, sm: 5, md: 8 },
//               mb: { xs: 2, sm: 4, md: 6 },
//               borderRadius: "10px",
//               fontFamily:'"Nunito Sans", "Roboto", "Arial", sans-serif',
//               textDecoration: "underline",
//               "&:hover": {
//                 background:
//                   "linear-gradient(90deg, #4E62F2 0%, #3E52D2 100%)",
//               },
//             }}
//             onClick={handleSubmit}
//           >
//             {loading ? "Sending..." : "Send Reset Link"}
//           </Button>

//           {/* Back to Login */}
//           <Box sx={{ textAlign: "center", mb: 4 }}>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: "#034A7F",
//                 cursor: "pointer",
//                 textDecoration: "underline",
//                 fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
//                 "&:hover": { color: "#023a6b" }
//               }}
//               onClick={() => navigate("/login")}
//             >
//               ← Back to Login
//             </Typography>
//           </Box>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };
 
// export default ForgotPassword;


import React, { useState } from "react";
import { 
  Box, 
  Button, 
  TextField, 
  Typography, 
  Link,
  InputAdornment,
  CircularProgress,
  Fade,
  Stack,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  EmailOutlined,
  Psychology,
  Hub,
  Speed,
  Security,
  Bolt,
  TrendingUp,
  ArrowBack
} from '@mui/icons-material';
import { API_BASE } from "../api/index.js";

// Branding Palette (Matched exactly to Login/Register)
const BRAND = {
  primary: "#008080", // Teal
  secondary: "#034A7F", // Navy
  textMain: "#1B2559",
  textSecondary: "#A3AED0",
  bgLight: "#F4F7FE",
  white: "#FFFFFF"
};

const ForgotPassword = () => {
  // --- EXISTING FUNCTIONALITY PRESERVED ---
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleSubmit = async () => {
    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setMessage("");

      const response = await fetch(`${API_BASE}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        // Optionally redirect after a delay
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setError(data.message || "Failed to send reset email");
      }

    } catch (error) {
      console.error("Forgot password error:", error);
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Reusable input style exactly matched from login.js
  const inputSx = { 
    "& .MuiOutlinedInput-root": { borderRadius: "14px", bgcolor: BRAND.bgLight, border: "none" },
    "& fieldset": { border: "none" }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: BRAND.white, overflow: "hidden" }}>
      
      {/* LEFT SECTION: EXACT FLEX & PADDING FROM LOGIN/REGISTER */}
      <Box sx={{ 
        flex: { xs: 1, md: 1, lg: 0.8 }, 
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "center",
        alignItems: "center", 
        px: { xs: 3, sm: 8, md: 10, lg: 15 },
        position: "relative",
        zIndex: 10
      }}>
        <Box sx={{ width: "100%", maxWidth: "420px" }}>
          
          {/* Logo & Header */}
          <Box sx={{ mb: 6, textAlign: isMobile ? 'center' : 'left' }}>
            <a href="https://lendingx.ai" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block" }}>
              <img 
                src="https://lendingx.ai/wp-content/uploads/2026/03/cropped-Png-300x79.png" 
                alt="LendingX Logo" 
                style={{ marginBottom: "32px", display: "block" }} 
              />
            </a>
            <Typography variant="h4" sx={{ fontWeight: 800, color: BRAND.textMain, mb: 1, letterSpacing: "-1px" }}>
              Reset Password
            </Typography>
            <Typography variant="body1" sx={{ color: BRAND.textSecondary, fontWeight: 500, lineHeight: 1.5, minHeight: "24px" }}>
              Enter your registered email address to receive a secure password reset link.
            </Typography>
          </Box>

          <Stack spacing={3}>
            {/* Success Message */}
            {message && (
              <Fade in={!!message}>
                <Box sx={{ p: 2, bgcolor: "#F0FDF4", border: "1px solid #BBF7D0", borderRadius: "12px" }}>
                  <Typography variant="body2" color="#16A34A" textAlign="center" fontWeight="600">
                    {message}
                  </Typography>
                </Box>
              </Fade>
            )}

            {/* Error Message */}
            {error && (
              <Fade in={!!error}>
                <Box sx={{ p: 2, bgcolor: "#FFF5F5", border: "1px solid #FFD1D1", borderRadius: "12px" }}>
                  <Typography variant="body2" color="#E53E3E" textAlign="center" fontWeight="600">
                    {error}
                  </Typography>
                </Box>
              </Fade>
            )}

            <Box>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 700, color: BRAND.textMain }}>Email Address</Typography>
              <TextField
                fullWidth
                type="email"
                placeholder="mail@lendingx.ai"
                variant="outlined"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError(""); // Clear error on type (preserved from original logic)
                }}
                error={!!error}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><EmailOutlined sx={{ color: BRAND.textSecondary, fontSize: 20 }} /></InputAdornment>,
                }}
                sx={inputSx}
              />
            </Box>
          </Stack>

          {/* Button matching Login/Register exact styling */}
          <Box sx={{ mt: 4 }}>
            <Button
              fullWidth
              variant="contained"
              disabled={loading}
              onClick={handleSubmit}
              sx={{
                bgcolor: BRAND.secondary,
                color: "white",
                py: 2,
                borderRadius: "14px",
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 700,
                boxShadow: "0px 12px 24px rgba(3, 74, 127, 0.25)",
                transition: "all 0.3s ease",
                "&:hover": { bgcolor: BRAND.primary, boxShadow: "none", transform: "translateY(-1px)" },
              }}
            >
              {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Send Reset Link"}
            </Button>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <Link 
              onClick={() => navigate("/login")} 
              sx={{ 
                display: "flex", alignItems: "center", gap: 0.5,
                color: BRAND.textSecondary, cursor: "pointer", fontWeight: 700, 
                textDecoration: "none", transition: "color 0.2s",
                "&:hover": { color: BRAND.primary }
              }}
            >
              <ArrowBack sx={{ fontSize: 16 }} /> Back to Login
            </Link>
          </Box>

        </Box>

        {/* Footer */}
        <Typography variant="caption" sx={{ position: "absolute", bottom: 24, color: BRAND.textSecondary, fontWeight: 500 }}>
          © 2026 LendingX.
        </Typography>
      </Box>

      {/* RIGHT SECTION: EXACT FLEX AND INTELLIGENCE PANEL FROM LOGIN/REGISTER */}
      <Box sx={{ 
        flex: { xs: 0, md: 1, lg: 1.2 }, 
        display: { xs: "none", md: "flex" },
        position: "relative",
        background: `linear-gradient(145deg, ${BRAND.secondary} 0%, #011627 100%)`,
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        p: 6
      }}>
        {/* Animated Mesh Background */}
        <Box sx={{
          position: "absolute", width: "100%", height: "100%",
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)`,
          backgroundSize: "40px 40px",
          animation: "meshMovement 60s linear infinite",
          "@keyframes meshMovement": { "0%": { transform: "translate(0, 0)" }, "100%": { transform: "translate(-40px, -40px)" } }
        }} />

        <Box sx={{
          position: "absolute", top: "20%", left: "10%", width: "300px", height: "300px",
          bgcolor: BRAND.primary, filter: "blur(120px)", opacity: 0.15, borderRadius: "50%"
        }} />

        <Box sx={{ position: "relative", zIndex: 5, maxWidth: "540px", width: "100%" }}>
          <Box sx={{ 
            bgcolor: "rgba(255, 255, 255, 0.03)",
            backdropFilter: "blur(20px)",
            borderRadius: "48px",
            p: 6,
            border: "1px solid rgba(255, 255, 255, 0.1)",
            boxShadow: "0 40px 80px rgba(0,0,0,0.3)",
            position: "relative"
          }}>
            
            <Psychology sx={{ fontSize: 64, color: BRAND.primary, mb: 3 }} />
            
            <Typography variant="h3" sx={{ 
              color: BRAND.white, fontWeight: 800, mb: 2, lineHeight: 1.1, letterSpacing: "-1.5px" 
            }}>
              AI-Powered <br /> Credit Intelligence
            </Typography>
            
            <Typography variant="h6" sx={{ color: "rgba(255,255,255,0.7)", fontWeight: 400, mb: 4, lineHeight: 1.6 }}>
              Unlock hyper-accurate lending decisions with real-time behavioral insights and predictive modeling.
            </Typography>

            <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap", gap: 1 }}>
              {[
                { label: '360° Data Unification', icon: <Hub sx={{ fontSize: 14 }} /> },
                { label: 'Risk Engine', icon: <Speed sx={{ fontSize: 14 }} /> },
                { label: 'Fraud Shield', icon: <Security sx={{ fontSize: 14 }} /> },
                { label: 'Instant Decisions', icon: <Bolt sx={{ fontSize: 14 }} /> },
                { label: 'High-Conversion Prospecting', icon: <TrendingUp sx={{ fontSize: 14 }} /> }
              ].map((item) => (
                <Box
                  key={item.label}
                  sx={{
                    display: "flex", alignItems: "center", gap: 1,
                    px: 2, py: 1, borderRadius: "30px",
                    bgcolor: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)"
                  }}
                >
                  <Box sx={{ color: BRAND.primary }}>{item.icon}</Box>
                  <Typography sx={{ color: BRAND.white, fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.5px" }}>
                    {item.label.toUpperCase()}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ForgotPassword;